import {ClientOrderInitialState} from '../states';
import * as Actions from './actions';

const clientOrderReducer = (state = ClientOrderInitialState, action) => {
    switch(action.type) {
        case Actions.ADD_ITEM:
            const items = [...state.orderItems, action.payload]
            return {...state, orderItems: items};
        case Actions.DELETE_ITEM:
            const filteredItems = [...state.orderItems].filter(({id}) => id !== action.payload)
            return {...state, orderItems: filteredItems};
        case Actions.DELETE_ALL_ITEMS:
            return {...state, orderItems: []};
        case Actions.ADD_ORDER:
            const orders = [...state.orders, action.payload]
            return {...state, orders: orders};
        case Actions.SET_ORDERS:
            return {...state, orders: [...action.payload]};
        case Actions.SET_ORDER_STATUS:
            const { orderId } = action.payload
            const order = state.orders.find(({id}) => id === orderId)

            // Cheeck order status
            if (order.status !== 'delivery' || order.status !== 'done') {
                const itemsStatus = order.items.filter(status => status !== 'canceled').reduce((acc,{status}) =>([...acc, status]),[])

                const isInProgress = itemsStatus.includes('in-progress')
                const isProduced = itemsStatus.every(status => status === 'done')

                order.status = isProduced ? 'produced' : isInProgress ? 'in-progress' : order.status
            }

            return {...state, orders:[...state.orders]};
        case Actions.SET_ITEM_ORDER_STATUS:
            const {orderId:newOrderId, itemId, status} = action.payload;
            const orderToUpdate = state.orders.find(({id}) => newOrderId === id)
            const item =  orderToUpdate.items.find(({id}) => id === itemId)
            item.status = status

            return {...state, orders: [...state.orders]}
        case Actions.SET_DELIVERY_METHOD:
            return {...state, additionalInfo: {...state.additionalInfo, deliveryMethod: action.payload}}
        case Actions.SET_EXPECTED_DATE:
            return {...state, additionalInfo: {...state.additionalInfo, expectedDate: action.payload}}
        case Actions.RESET_ADDITIONAL_INFO:
            return {...state, additionalInfo: {deliveryMethod: 'self', expectedDate: null}}
        default:
            return {...state}
    }
}
  
export default clientOrderReducer;